var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarePrioritiesLifestyle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 261 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_105_35486",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 147
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.822 144.134C156.362 149.129 189.665 145.812 214.783 136.387C239.881 126.969 256.927 111.398 259.679 91.8162C262.431 72.2343 250.337 52.5681 228.807 36.5972C207.26 20.6134 176.162 8.24528 140.622 3.2504C105.081 -1.74447 71.7787 1.57272 46.6603 10.9981C21.5622 20.4158 4.51589 35.9867 1.76383 55.5685C-0.988218 75.1504 11.1058 94.8167 32.6358 110.788C54.1832 126.771 85.2813 139.139 120.822 144.134Z",
    fill: "#F5F9FE",
    stroke: "#E1E1E1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_105_35486)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_105_35486)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.722,
    cy: 73.6924,
    rx: 129.725,
    ry: 70.6342,
    transform: "rotate(8 130.722 73.6924)",
    fill: "#F5F9FE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.8405 172.814C69.8405 172.814 38.307 135.295 47.7528 125.696C57.1986 116.098 73.0748 126.575 70.3547 115.875C67.6345 105.176 56.8061 94.7987 61.1798 86.6765C66.436 76.932 81.8188 84.8388 89.2671 88.2503C103.114 94.5972 118.449 95.299 113.14 86.4264C107.832 77.5538 93.9014 68.8827 98.9491 63.8246C105.824 56.9426 143.614 82.4209 159.786 102.386C169.464 114.326 176.52 106.02 175.54 98.3492C174.918 93.4856 168.061 83.411 175.252 78.8601C182.2 74.4689 198.378 88.0696 203.878 96.4697C218.281 118.46 194.699 172.616 194.699 172.616L69.8405 172.814Z",
    fill: "#C5CEDA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.1959,
    cy: 66.4398,
    rx: 9.64872,
    ry: 11.9334,
    transform: "rotate(-86.67 67.1959 66.4398)",
    fill: "#E7F0F7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.395,
    cy: 59.0561,
    rx: 8.42447,
    ry: 9.45087,
    transform: "rotate(-86.67 75.395 59.0561)",
    fill: "#E7F0F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.996 67.1111C95.6049 73.7457 88.7199 74.5439 80.5404 75.4159C53.9191 78.2387 61.4684 71.7735 61.8565 65.142C62.2445 58.5105 73.5405 53.7649 81.7821 54.2425C90.0236 54.7201 96.3841 60.4796 95.996 67.1111Z",
    fill: "#E7F0F7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.637,
    cy: 55.2591,
    rx: 9.96715,
    ry: 8.05966,
    transform: "rotate(-3.33 187.637 55.2591)",
    fill: "#E7F0F7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.792,
    cy: 49.0885,
    rx: 7.89581,
    ry: 7.03637,
    transform: "rotate(-3.33 180.792 49.0885)",
    fill: "#E7F0F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.422 56.0339C163.747 61.6207 169.483 62.2881 176.302 63.0175C198.488 65.3919 192.195 59.954 191.87 54.3733C191.545 48.7927 182.14 44.8043 175.268 45.2047C168.396 45.6051 163.1 50.4532 163.422 56.0339Z",
    fill: "#E7F0F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.359 126.553C199.33 131.457 198.246 139.806 192.134 143.21C188.792 145.022 185.04 145.956 181.234 145.922C170.953 145.922 162.616 139.5 162.616 131.575C162.616 131.575 160.51 124.349 168.52 121.207C176.53 118.065 170.832 111.368 166.413 105.085C161.995 98.8018 162.837 92.3146 167.035 76.8202C171.233 61.3257 174.607 56.7216 182.393 56.3011C190.18 55.8806 188.511 73.7559 188.98 77.5715C189.726 83.6104 202.801 89.5905 201.536 97.1289C200.272 104.667 191.019 115.555 191.019 115.555C191.019 115.555 187.442 118.486 190.596 122.462C191.77 123.897 193.026 125.263 194.359 126.553Z",
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.257 173.02V92.076",
    stroke: "#658FDF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.778 103.54C180.778 103.54 176.727 99.5418 176.262 96.2448",
    stroke: "#658FDF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.431 121.258C180.431 121.258 183.454 118.981 184.252 116.394",
    stroke: "#658FDF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.778 142.449C180.778 142.449 176.415 138.928 176.262 135.848",
    stroke: "#658FDF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.246,
    cy: 27.1287,
    rx: 11.9334,
    ry: 9.64872,
    transform: "rotate(-8.94 135.246 27.1287)",
    fill: "#E7F0F7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.363,
    cy: 20.5752,
    rx: 9.45086,
    ry: 8.42447,
    transform: "rotate(-8.94 126.363 20.5752)",
    fill: "#E7F0F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.558 30.7548C107.595 37.3123 114.505 37.4416 122.716 37.5278C149.415 37.7525 141.291 32.0571 140.248 25.4996C139.205 18.9421 127.533 15.3217 119.403 16.5962C111.273 17.8708 105.508 24.1881 106.558 30.7548Z",
    fill: "#E7F0F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.218 28.7201C118.696 33.5768 122.353 37.0144 117.478 37.4813C112.603 37.9482 101.042 35.3033 100.561 30.4465C100.15 25.6276 103.703 21.3743 108.534 20.9019C113.366 20.4295 117.681 23.9135 118.218 28.7201Z",
    fill: "#E7F0F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.73 84.2849L114.872 101.108C114.872 101.108 127.417 104.65 137.394 100.066L136.7 69.1186L128.679 61.3737L127.532 62.0053L122.8 60.4649C121.834 60.4253 120.916 60.8913 120.373 61.6972",
    fill: "#4A90E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.244 56.2938C122.244 56.2938 122.244 59.9087 121.75 60.3625C121.256 60.8163 127.073 64.3687 128.351 63.4329L129.016 58.854",
    fill: "#8E6864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.32 58.7518L130.788 59.3699C131.383 59.4903 132.001 59.3937 132.529 59.0979C133.152 58.74 133.543 58.0906 133.565 57.3798L133.619 53.6253L134.774 53.375C134.936 53.3485 135.079 53.257 135.17 53.1223C135.261 52.9876 135.291 52.8217 135.253 52.6643L134.267 49.1168C132.651 45.6589 126.753 45.5971 124.765 47.3554C122.984 48.9407 122.026 53.4893 122.026 53.4893C122.026 53.4893 120.92 56.0541 122.915 57.0801L124.02 57.6456C125.06 58.1703 126.171 58.543 127.32 58.7518Z",
    fill: "#A3746D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.373,
    cy: 52.4724,
    rx: 2.4318,
    ry: 2.4318,
    fill: "#A3746D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.847 103.193C150.847 103.193 154.549 106.134 154.369 108.528C154.19 110.923 152.848 112.994 152.502 112.918C152.155 112.842 151.826 112.123 151.616 110.052C151.406 107.981 149.487 106.993 149.697 108.937C149.907 110.88 149.77 111.122 149.295 111.101C148.821 111.08 145.231 106.727 146.205 106.113L150.847 103.193Z",
    fill: "#A3746D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.181 166.634L113.73 166.767L113.733 105.972L128.668 116.205L122.181 166.634Z",
    fill: "#000B64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.343 166.179L135.963 166.767L125.542 104.93L141.522 116.394L145.343 166.179Lnan nanL145.343 166.179Z",
    fill: "#000B64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.73 106.214L114.84 100.988C114.84 100.988 127.893 104.397 137.394 100.066L141.522 116.394H113.73",
    fill: "#000B64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.461 108.765C105.461 108.765 104.922 113.253 106.864 114.925C108.806 116.597 111.38 117.3 111.578 117.034C111.775 116.768 111.479 116.022 110.07 114.353C108.661 112.684 109.355 110.746 110.659 112.33C111.963 113.913 112.256 114.002 112.595 113.693C112.934 113.384 112.324 107.913 111.131 108.059L105.461 108.765Z",
    fill: "#A3746D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.04 51.6865C119.04 51.6865 118.131 49.1124 117.191 47.7098C116.251 46.3072 117.302 43.352 120.245 42.3649C120.245 42.3649 120.217 38.3695 126.217 39.4597C132.217 40.5499 135.022 40.653 137.601 39.719C137.601 39.719 138.668 39.3035 138.329 41.5933C137.99 43.8831 138.138 46.2791 133.348 47.9816C133.348 47.9816 129.154 45.6543 125.918 47.0444C125.05 47.4198 124.344 48.0996 123.93 48.9593C123.407 50.0464 122.522 51.9676 122.236 53.1672C122.236 53.1672 122.072 51.3647 120.695 51.2366C119.317 51.1086 119.04 51.6865 119.04 51.6865Z",
    fill: "#626363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.668 61.1574L135.776 62.6672C136.605 62.8188 137.269 63.4455 137.474 64.2698L142.38 86.2795C142.454 86.6041 142.572 86.9166 142.733 87.2076L151.563 103.565C151.637 103.711 151.585 103.891 151.444 103.973L145.738 107.305C145.577 107.407 145.366 107.367 145.253 107.213L137.024 95.9849",
    fill: "#4A90E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.721 60.4626L111.006 65.9185C110.578 66.1325 110.24 66.4922 110.053 66.933L103.21 84.3399C102.989 84.8756 102.913 85.4604 102.991 86.0348L103.971 108.922C104.076 109.492 104.618 109.873 105.189 109.779L110.972 109.077C111.506 109.033 111.913 108.58 111.899 108.044L111.501 89.5855C111.475 89.1464 111.561 88.7079 111.751 88.3112L118.186 74.8292",
    fill: "#4A90E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.51 54.9126C133.51 54.9126 133.122 54.4831 132.058 54.5679C130.993 54.6526 130.642 55.1522 130.333 55.1288C130.08 55.1504 129.849 55.0013 129.794 54.7811C129.794 54.7811 129.429 55.1405 130.224 55.4297C131.019 55.719 133.444 55.5816 133.51 55.4297C133.539 55.2584 133.539 55.084 133.51 54.9126Z",
    fill: "#626363"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_105_35486",
    x: 1.87695,
    y: 1.43558,
    width: 257.689,
    height: 147.514,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_105_35486"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_105_35486"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarePrioritiesLifestyle);
export default __webpack_public_path__ + "static/media/Care Priorities - Lifestyle.3a5affb62df0470a82df5ab8396f4349.svg";
export { ForwardRef as ReactComponent };